import type { ReactNode } from 'react';

/**
 * Status pill — Field Notes rebuild (epic #950 PR-8, formerly the
 * console-shared `createStatusChip` factory instantiation). Variants
 * ride the token tint/line families; the pill silhouette is preserved
 * from the factory config.
 */
type Variant = 'ok' | 'warning' | 'error' | 'neutral';

const VARIANT_CLASSES: Record<Variant, string> = {
  ok: 'border border-ok-line bg-ok-tint text-ink',
  warning: 'border border-warn-line bg-warn-tint text-ink',
  error: 'border border-bad-line bg-bad-tint text-bad',
  neutral: 'border border-line bg-active text-ink-mid',
};

interface Props {
  readonly variant: Variant;
  readonly label: ReactNode;
  readonly testId?: string;
}

export function StatusChip({ variant, label, testId }: Props): JSX.Element {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-mono text-mono-label uppercase ${VARIANT_CLASSES[variant]}`}
    >
      {label}
    </span>
  );
}
